import {
  CompassOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Alert, Button, Card, Divider, Result, Space, Typography } from "antd";
import { useOutletContext } from "react-router-dom";
import "./LocationAccessControl.css";

const { Title, Text, Paragraph } = Typography;

export const LocationAccessControl = ({ children }) => {
  const { isGeolocationEnabled, isGeolocationAvailable, getPosition } =
    useOutletContext();

  // 1. Hardware/Browser doesn't support it at all
  if (!isGeolocationAvailable) {
    return (
      <Card style={{ borderRadius: 0, marginTop: 16 }}>
        <Result
          status="warning"
          title="GPS Not Supported"
          subTitle="Your current browser or device does not support location services. Please try a different device or update your browser."
        />
      </Card>
    );
  }

  // 2. Permission is denied or not yet granted
  if (!isGeolocationEnabled) {
    return (
      <Card style={{ borderRadius: 0, marginTop: 0 }}>
        <Result
          status="info"
          icon={<CompassOutlined style={{ color: "#1890ff" }} />}
          title="Location Access Required"
          subTitle="To capture attendees accurately, we must tag their geographic coordinates."
          extra={[
            <Button
              type="primary"
              key="request"
              size="large"
              icon={<SafetyCertificateOutlined />}
              onClick={() => getPosition()}
            >
              Request Permission
            </Button>,
          ]}
        >
          <div
            style={{ textAlign: "left", maxWidth: "600px", margin: "0 auto" }}
          >
            <Divider orientation="left">How to enable</Divider>
            <Paragraph>
              <Space direction="vertical">
                <Text>
                  <SettingOutlined /> 1. Go to your browser or device{" "}
                  <strong>settings</strong> and find app permissions.
                </Text>
                <Text>
                  <CompassOutlined /> 2. Ensure <strong>Location</strong> is set
                  to "Allow while using the app".
                </Text>
                <Alert
                  message="Pro-tip"
                  description="If you've already granted permission in settings, click the Request button above to refresh the status."
                  type="info"
                  showIcon
                  style={{ marginTop: 16 }}
                />
              </Space>
            </Paragraph>
          </div>
        </Result>
      </Card>
    );
  }

  // 3. Everything is fine -> Render the Actual Capture Form
  return <>{children}</>;
};
